export default __webpack_public_path__ + "static/media/Billy_Icon.1b6caac2.png";